<div class="table-responsive" style="margin-bottom: 20px">
  <table class="table table-bordered table-hover">
    <thead>
    <tr>
      <th></th>
      <th>Тип</th>
      <th>Обл.</th>
      <th>Район/напр</th>
      <th>Адрес</th>
      <th>Крыша</th>
      <th>S</th>
      <th>Этажность</th>
      <th>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field ==='price' && (sort.value==='ASC' || sort.value==='DESC')"
             (click)="changeSort('price', 'DESC')">
          <i class="fas fa-sort icon-color"></i>$
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='price' || (sort.field==='price' && sort.value==='ASC')"
             (click)="changeSort('price', 'ASC')">
          <i class="fas fa-sort-down icon-color"></i>$
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='price' || (sort.field==='price' && sort.value==='DESC')"
             (click)="changeSort('price', 'DESC')">
          <i class="fas fa-sort-up icon-color"></i>$
        </div>
      </th>
      <th>$м2</th>
      <th *ngIf="user.access===4">Агентство</th>
      <th *ngIf="user.access!==4">Сотрудник</th>
      <th *ngIf="access.houses_created">
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field ==='created_at' && (sort.value==='ASC' || sort.value==='DESC')"
             (click)="changeSort('created_at', 'DESC')">
          <i class="fas fa-sort icon-color"></i>Дата доб.
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='created_at' || (sort.field==='created_at' && sort.value==='ASC')"
             (click)="changeSort('created_at', 'ASC')">
          <i class="fas fa-sort-down icon-color"></i>Дата доб.
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='created_at' || (sort.field==='created_at' && sort.value==='DESC')"
             (click)="changeSort('created_at', 'DESC')">
          <i class="fas fa-sort-up icon-color"></i>Дата доб.
        </div>
      </th>
      <th>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field ==='updated_at' && (sort.value==='ASC' || sort.value==='DESC')"
             (click)="changeSort('updated_at', 'DESC')">
          <i class="fas fa-sort icon-color"></i>Дата обн.
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='updated_at' || (sort.field==='updated_at' && sort.value==='ASC')"
             (click)="changeSort('updated_at', 'ASC')">
          <i class="fas fa-sort-down icon-color"></i>Дата обн.
        </div>
        <div class="nobr cursor" style="width: 100%"
             [hidden]="sort.field!=='updated_at' || (sort.field==='updated_at' && sort.value==='DESC')"
             (click)="changeSort('updated_at', 'DESC')">
          <i class="fas fa-sort-up icon-color"></i>Дата обн.
        </div>
      </th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let house of houses | paginate: { itemsPerPage: limit, currentPage: page, totalItems: countHouses }; let i = index">
      <tr>
        <td class="text-center">
          <a routerLink="house/{{house.id}}" target="_self">
            <i class="fas fa-pencil-alt icon-color"></i>
          </a>
        </td>
        <td>{{house.type.title}}</td>
        <td>{{house.location.city.district_country.region.title}}</td>
        <td>
          <ng-container *ngIf="house.location.city.district_country.region.id === 5 ">
            {{house.location.direction.small_title}}
          </ng-container>
          <ng-container *ngIf="house.location.city.district_country.region.id !== 5 ">
            {{house.location.city.district_country.title}}
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="house.location.city.title.length >0 ">
            {{house.location.city.title}}
          </ng-container>
          <ng-container *ngIf="house.location.street.title.length >0 ">
            <br/> {{house.location.street.title}}
          </ng-container>
          <ng-container *ngIf="house.location.house !== '0' && house.location.house !== ''">
            ,{{house.location.house}}
          </ng-container>
          <ng-container *ngIf="house.location.housing !== '0' && house.location.housing !== ''">
            / {{house.location.housing}}
          </ng-container>
        </td>
        <td>{{house.roof.small_title}}</td>
        <td>{{house.area}}/{{house.area_leave}}/{{house.area_kitchen}}</td>
        <td>{{house.storeys}}</td>
        <td>{{house.price}}</td>
        <td>{{house.price_sqr}}</td>
        <td *ngIf="user.access===4">{{house.company.title}}</td>
        <td *ngIf="user.access!==4">{{house.user.user_information.surname}} {{house.user.user_information.name}}</td>
        <td *ngIf="access.houses_created">
          {{house.created_at | date: 'dd.MM.yyyy'}}
        </td>
        <td>
          {{house.updated_at | date: 'dd.MM.yyyy'}}
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</div>

<div class="row no-gutters">
  <!--Пагинация -->
  <div class="col-12 text-center">
    <pagination-controls (pageChange)="getHousesByPage($event)" maxSize="7" previousLabel="" nextLabel=""
                         directionLinks="true" autohide="true"></pagination-controls>
  </div>
</div>


